import { makeObservableRowBase, RowBase } from 'shared/ui/TableNew/model/RowBase'
import { type IResponseAuthClient } from 'entities/Auth'

export class AuthClientRow extends RowBase<IResponseAuthClient> {
  constructor(origin: IResponseAuthClient) {
    super(origin)
    makeObservableRowBase(this)
  }

  get name() {
    return this.origin.name
  }

  get secret() {
    return this.origin.secret
  }

  get created_at() {
    return this.origin.created_at
  }
}
